import { ca } from '@cian/analytics';
import { getAnalyticsPageCard, getAnalyticsProductsCard } from '../../utils/analytics';
import { TDeviceType } from '@cian/ui-kit';

interface IClickProjectCardParams {
  position: number;
  builderId: number;
  builderName: string;
  projectId: number;
  projectName: string;
  deviceType: TDeviceType;
}

export const trackClickProjectCard = ({
  position,
  builderId,
  builderName,
  projectId,
  projectName,
  deviceType,
}: IClickProjectCardParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click',
    label: 'HouseProjects',
    page: getAnalyticsPageCard(deviceType),
    products: getAnalyticsProductsCard(builderId, position, {
      house_id: `${builderName} | ${projectName} | ${projectId}`,
    }),
  });
};

interface IClickPhoneButtonParams {
  position: number;
  projectId: number;
  builderId: number;
  deviceType: TDeviceType;
}

export const trackClickPhoneButton = ({ position, builderId, deviceType, projectId }: IClickPhoneButtonParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_builder_contact_block_project',
    label: `/sale/CP/object_type=2/spec=company/${builderId}/from_developer=1/repres=0/owner=0/pod_snos=0`,
    page: getAnalyticsPageCard(deviceType),
    products: [
      {
        id: projectId,
        offerType: 'CSP',
        position,
      },
    ],
  });
};
